var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"widgets__item calc_widget btn--size",on:{"click":function () { this$1.$store.state.calcModal = true }}},[_vm._v("Рассчитать лизинг")])}
var staticRenderFns = []

export { render, staticRenderFns }